(function($) {

    $.fn.songeditor = function (options) {

        var $elem = this;
        var settings = $.extend({}, options);

        var artist = $elem.find('.artist').html();
        var song = $elem.find('.song').html();

        var $artist = $('<input type="text" class="modal-input" name="artist" value="'+artist+'" />');
        var $song = $('<input type="text" class="modal-input" name="song" value="'+song+'" />');

        var height = (options.height) ? options.height : 240;
        var width = (options.width) ? options.width : 400;

        var $title = $('<h2 class="modal-header">Edit track info</h2>');
        var $btn = $('<a class="btn btn-medium modal-save" style="margin: 0 auto;" href="javascript:">Save</a>');

        $btn.click(function() {
            settings.finished(settings.slug, $artist.val(), $song.val());
            $content.close();
        });

        var $content = $('<div style="text-align: center;"></div>');
        $content.append($title).append($artist).append($song).append($btn);
        $content.modal({width: width, height: height});

    };

}( jQuery ));